(function () {
  var STORAGE_KEY = 'rug-estate-wishlist';

  function readAll() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function writeAll(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    return readAll().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(item) {
    var items = readAll();
    var index = items.findIndex(function (existing) {
      return String(existing.id) === String(item.id);
    });

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(item);
    }

    writeAll(items);
    return index === -1;
  }

  function remove(id) {
    var items = readAll().filter(function (item) {
      return String(item.id) !== String(id);
    });
    writeAll(items);
  }

  window.RugWishlist = {
    getAll: readAll,
    has: has,
    toggle: toggle,
    remove: remove,
  };

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.item = {
        id: this.dataset.productId,
        handle: this.dataset.productHandle,
        title: this.dataset.productTitle,
        image: this.dataset.productImage,
        price: this.dataset.productPrice,
        url: this.dataset.productUrl,
      };

      this.render();
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.RugWishlist.toggle(this.item);
        this.render();
      });
      this.onChange = () => this.render();
      document.addEventListener('wishlist:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    render() {
      var active = window.RugWishlist.has(this.item.id);
      this.button.classList.toggle('is-active', active);
      this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  class WishlistCount extends HTMLElement {
    connectedCallback() {
      this.render();
      this.onChange = () => this.render();
      document.addEventListener('wishlist:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    render() {
      var count = window.RugWishlist.getAll().length;
      this.textContent = count;
      this.hidden = count === 0;
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' AUD';
  }

  function itemRowHTML(item, itemClass) {
    return (
      '<li class="' + itemClass + '" data-wishlist-item="' + item.id + '">' +
      '<a href="' + item.url + '" class="' + itemClass + '-media">' +
      '<img src="' + item.image + '" alt="" loading="lazy" width="80" height="80">' +
      '</a>' +
      '<div class="' + itemClass + '-info">' +
      '<a href="' + item.url + '" class="' + itemClass + '-title">' + item.title + '</a>' +
      '<span class="' + itemClass + '-price" data-wishlist-item-price>' + item.price + '</span>' +
      '<span class="' + itemClass + '-stock" data-wishlist-item-stock hidden>' +
      '<span class="' + itemClass + '-stock-dot"></span><span data-wishlist-item-stock-label></span>' +
      '</span>' +
      '</div>' +
      '<button type="button" class="' + itemClass + '-remove" data-remove-id="' + item.id + '" aria-label="Remove">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m3 0-1 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7"></path></svg>' +
      '</button>' +
      '</li>'
    );
  }

  class WishlistDrawer extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-wishlist-list]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.summary = this.querySelector('[data-wishlist-summary]');
      this.count = this.querySelector('[data-wishlist-count-label]');
      this.total = this.querySelector('[data-wishlist-total]');
      this.closeButtons = this.querySelectorAll('[data-wishlist-close]');
      this.trigger = document.querySelector('[data-wishlist-trigger]');

      if (this.trigger) {
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      }

      this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.addEventListener('click', (event) => {
        if (event.target === this) this.close();
      });

      this.onChange = () => this.renderList();
      document.addEventListener('wishlist:change', this.onChange);
      this.renderList();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('wishlist-drawer-open');
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('wishlist-drawer-open');
    }

    renderList() {
      if (!this.list) return;
      var items = window.RugWishlist.getAll();

      if (this.empty) {
        this.empty.hidden = items.length > 0;
      }

      if (this.summary) {
        this.summary.hidden = items.length === 0;
      }

      if (this.count) {
        this.count.textContent = items.length + (items.length === 1 ? ' item saved' : ' items saved');
      }

      this.list.innerHTML = items
        .map(function (item) {
          return itemRowHTML(item, 'wishlist-drawer__item');
        })
        .join('');

      this.list.querySelectorAll('[data-remove-id]').forEach((button) => {
        button.addEventListener('click', () => {
          window.RugWishlist.remove(button.dataset.removeId);
        });
      });

      refreshLiveData(this.list, this.total, items);
    }
  }

  function refreshLiveData(listEl, totalEl, items) {
    if (!listEl) return;
    var totals = {};

    items.forEach(function (item) {
      fetch(item.url + '.js')
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          totals[item.id] = product.price;

          var row = listEl.querySelector('[data-wishlist-item="' + item.id + '"]');
          if (!row) return;

          var priceEl = row.querySelector('[data-wishlist-item-price]');
          if (priceEl) priceEl.textContent = formatMoney(product.price);

          var stockEl = row.querySelector('[data-wishlist-item-stock]');
          var stockLabel = row.querySelector('[data-wishlist-item-stock-label]');
          if (stockEl && stockLabel) {
            stockEl.hidden = false;
            stockEl.classList.toggle('is-out-of-stock', !product.available);
            stockLabel.textContent = product.available ? 'In stock' : 'Out of stock';
          }

          if (totalEl) {
            var sum = Object.keys(totals).reduce(function (acc, id) {
              return acc + totals[id];
            }, 0);
            totalEl.textContent = formatMoney(sum);
          }
        })
        .catch(function () {});
    });
  }

  function cardHTML(item) {
    return (
      '<li class="rug-wishlist-card" data-wishlist-item="' + item.id + '">' +
      '<div class="rug-wishlist-card__media">' +
      '<a href="' + item.url + '"><img src="' + item.image + '" alt="" loading="lazy" width="400" height="400"></a>' +
      '<button type="button" class="rug-wishlist-card__heart" data-remove-id="' + item.id + '" aria-label="Remove from wishlist">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg>' +
      '</button>' +
      '</div>' +
      '<div class="rug-wishlist-card__body">' +
      '<a href="' + item.url + '" class="rug-wishlist-card__title">' + item.title + '</a>' +
      '<p class="rug-wishlist-card__size" data-wishlist-item-size hidden></p>' +
      '<p class="rug-wishlist-card__price">' +
      '<span class="rug-wishlist-card__price-now" data-wishlist-item-price>' + item.price + '</span> ' +
      '<span class="rug-wishlist-card__price-compare" data-wishlist-item-compare hidden></span>' +
      '</p>' +
      '<div class="rug-wishlist-card__actions">' +
      '<button type="button" class="rug-wishlist-card__add" data-add-to-cart="' + item.id + '" disabled>' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h12l-1 13a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 7Z"></path><path d="M9 7V5a3 3 0 0 1 6 0v2" stroke-linecap="round"></path></svg>' +
      'Add to Cart' +
      '</button>' +
      '<button type="button" class="rug-wishlist-card__remove" data-remove-id="' + item.id + '" aria-label="Remove">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m3 0-1 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7"></path></svg>' +
      '</button>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function refreshCartBubble() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    fetch(window.routes.cart_url + '.js')
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (!cart) return;
        var bubble = cartIcon.querySelector('.cart-count-bubble');

        if (cart.item_count === 0) {
          if (bubble) bubble.remove();
          return;
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartIcon.appendChild(bubble);
        }

        bubble.innerHTML =
          (cart.item_count < 100 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '') +
          '<span class="visually-hidden">' + cart.item_count + ' items</span>';
      })
      .catch(function () {});
  }

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-wishlist-list]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.count = this.querySelector('[data-wishlist-count-label]');
      this.sortSelect = this.querySelector('[data-wishlist-sort]');
      this.viewButtons = this.querySelectorAll('[data-wishlist-view]');
      this.notice = this.querySelector('[data-wishlist-notice]');
      this.priceCache = {};
      this.sortMode = 'recent';

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => {
          this.sortMode = this.sortSelect.value;
          this.reorder();
        });
      }

      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.viewButtons.forEach((btn) => btn.classList.remove('is-active'));
          button.classList.add('is-active');
          if (this.list) this.list.classList.toggle('rug-wishlist-page__grid--list', button.dataset.wishlistView === 'list');
        });
      });

      this.onChange = () => this.renderList();
      document.addEventListener('wishlist:change', this.onChange);
      this.renderList();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    sortedItems(items) {
      var sorted = items.slice();
      var priceCache = this.priceCache;

      switch (this.sortMode) {
        case 'price-asc':
          sorted.sort(function (a, b) {
            return (priceCache[a.id] ?? parseFloat(a.price.replace(/[^0-9.]/g, ''))) -
              (priceCache[b.id] ?? parseFloat(b.price.replace(/[^0-9.]/g, '')));
          });
          break;
        case 'price-desc':
          sorted.sort(function (a, b) {
            return (priceCache[b.id] ?? parseFloat(b.price.replace(/[^0-9.]/g, ''))) -
              (priceCache[a.id] ?? parseFloat(a.price.replace(/[^0-9.]/g, '')));
          });
          break;
        case 'title-asc':
          sorted.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
          break;
        default:
          sorted.reverse();
      }

      return sorted;
    }

    reorder() {
      if (!this.list) return;
      var items = this.sortedItems(window.RugWishlist.getAll());
      items.forEach((item) => {
        var row = this.list.querySelector('[data-wishlist-item="' + item.id + '"]');
        if (row) this.list.appendChild(row);
      });
    }

    renderList() {
      if (!this.list) return;
      var items = window.RugWishlist.getAll();

      if (this.empty) this.empty.hidden = items.length > 0;
      if (this.notice) this.notice.hidden = items.length === 0;
      if (this.count) {
        this.count.textContent = items.length + (items.length === 1 ? ' item' : ' items');
      }

      this.list.innerHTML = this.sortedItems(items)
        .map(function (item) {
          return cardHTML(item);
        })
        .join('');

      this.list.querySelectorAll('[data-remove-id]').forEach((button) => {
        button.addEventListener('click', () => {
          window.RugWishlist.remove(button.dataset.removeId);
        });
      });

      this.list.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.addEventListener('click', () => {
          var variantId = button.dataset.variantId;
          if (!variantId) return;
          button.disabled = true;
          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then((response) => response.json())
            .then((response) => {
              button.disabled = false;
              if (response.status) return;
              button.classList.add('is-added');
              button.querySelector('svg')?.remove();
              button.textContent = 'Added';
              refreshCartBubble();
              setTimeout(() => {
                button.classList.remove('is-added');
                button.textContent = 'Add to Cart';
              }, 2000);
            })
            .catch(() => {
              button.disabled = false;
            });
        });
      });

      this.enrich(items);
    }

    enrich(items) {
      var list = this.list;
      var priceCache = this.priceCache;

      items.forEach((item) => {
        fetch(item.url + '.js')
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (!product) return;
            priceCache[item.id] = product.price;

            var row = list.querySelector('[data-wishlist-item="' + item.id + '"]');
            if (!row) return;

            var priceEl = row.querySelector('[data-wishlist-item-price]');
            if (priceEl) priceEl.textContent = formatMoney(product.price);

            var compareEl = row.querySelector('[data-wishlist-item-compare]');
            if (compareEl && product.compare_at_price > product.price) {
              compareEl.textContent = formatMoney(product.compare_at_price);
              compareEl.hidden = false;
            }

            var sizeOption = (product.options_with_values || []).find(function (option) {
              return option.name === 'Size';
            });
            var sizeEl = row.querySelector('[data-wishlist-item-size]');
            if (sizeEl && sizeOption && sizeOption.values[0]) {
              sizeEl.textContent = sizeOption.values[0];
              sizeEl.hidden = false;
            }

            var variant = product.variants.find(function (v) {
              return v.available;
            }) || product.variants[0];
            var addButton = row.querySelector('[data-add-to-cart]');
            if (addButton && variant) {
              addButton.dataset.variantId = variant.id;
              addButton.disabled = false;
            }
          })
          .catch(function () {});
      });
    }
  }

  function initWishlistHero() {
    var saveButton = document.querySelector('[data-wishlist-save]');
    var emailButton = document.querySelector('[data-wishlist-email]');
    var toast = document.querySelector('[data-wishlist-toast]');

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(showToast.timer);
      showToast.timer = setTimeout(() => {
        toast.hidden = true;
      }, 3000);
    }

    if (saveButton) {
      saveButton.addEventListener('click', () => {
        showToast('Your favourites are saved in this browser.');
      });
    }

    if (emailButton) {
      emailButton.addEventListener('click', (event) => {
        var items = window.RugWishlist.getAll();
        if (items.length === 0) return;
        event.preventDefault();
        var body = 'Check out my rug favourites:\n\n' +
          items
            .map(function (item) {
              return item.title + ' (' + item.price + ') - ' + item.url;
            })
            .join('\n');
        window.location.href = 'mailto:?subject=' + encodeURIComponent('My Rug Favourites') +
          '&body=' + encodeURIComponent(body);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistHero);
  } else {
    initWishlistHero();
  }

  if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);
  if (!customElements.get('wishlist-count')) customElements.define('wishlist-count', WishlistCount);
  if (!customElements.get('wishlist-drawer')) customElements.define('wishlist-drawer', WishlistDrawer);
  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);
})();
